import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'

import {unregister as unregisterServiceWorker} from './registerServiceWorker'

import { Router } from 'react-router'
import createBrowserHistory from 'history/createBrowserHistory'
import store from './store'

import './global.css'

import App from './App'

const {
  BUGSNAG_API_KEY,
  BUGSNAG_TEST_SWITCH
} = process.env

let BugsnagErrorBoundary = null;

if (BUGSNAG_API_KEY) {
  const bugsnagClient = bugsnag(BUGSNAG_API_KEY)
  bugsnagClient.use(bugsnagReact, React)

  BugsnagErrorBoundary = bugsnagClient.getPlugin('react')

  if (BUGSNAG_TEST_SWITCH.toUpperCase() === 'ON') {
    bugsnagClient.notify(new Error('Test error'))
  }
} else {
  BugsnagErrorBoundary = ({ children }) => <Fragment>{children}</Fragment>
}



const history = createBrowserHistory()

ReactDOM.render(
  <BugsnagErrorBoundary>
    <Provider store={store}>
      <Router history={history}>
        <App/>
      </Router>
    </Provider>
  </BugsnagErrorBoundary>
, document.getElementById('root'));
//registerServiceWorker();
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js